<template>
  <van-form ref="loginForm" class="wra">
    <van-field
      v-model="username"
      name="账号"
      size="large"
      label="账号"
      placeholder="请输入一尘账号"
      :rules="[{ required: true }]"
    />
    <van-field
      v-model="password"
      type="password"
      name="密码"
      size="large"
      label="密码"
      placeholder="请输入一尘密码"
      :rules="[{ required: true }]"
    />

    <div style="font-size: 14px;padding-left: 20px;margin-top: 10px;">
      <van-checkbox v-model="checked"
        >同意
        <span @click.stop="show = true" style="color: red;">《账号授权协议》</span></van-checkbox
      >
    </div>

    <div style="margin: 16px;">
      <van-button round block type="info" native-type="button" @click="handleLogin"
        >登录</van-button
      >
    </div>

    <van-popup
      safe-area-inset-bottom
      v-model="show"
      closeable
      position="center"
      :style="{ width: '85%', height: '80%' }"
    >
      <div style="font-size: 14px;padding:20px">
        <h1 style="text-align: center;">账户授权协议</h1>
        <h3 style="text-indent: 10px;">
          (一尘盯盘助手)一尘网发帖回帖服务协议 在使用此功能服务服务之前，请您（即用户）仔细阅读下
          述协议条款。一旦您点击确认本协议，即表示您已接受了
          以下所述的条款和条件，同意受本协议约束。如果您不同
          意接受全部的条款和条件，那么您将无法使用本协议约定的技术服务。
        </h3>
        <h4>第一条服务说明</h4>
        1.1通过一尘盯盘助手进行发帖回帖操作时，可自由选择自行通过您自有的一尘网账户和密码登录进行发帖和回帖操作，也可选择将您的一尘账户和密码授权给(一尘盯盘助手)进行发帖/回帖。<br />
        1.2为了更好地给您提供发帖、回帖服务，一旦您选择一尘网发帖回帖服务，您同意将您的一尘账户和密码授权给(一尘盯盘助手)，允许(一尘盯盘助手)使用您的一尘账户和密码登陆，并完成
        发帖、回帖及其相关查询操作。 1.3接受此协议，代表自愿委托使用我的一尘帐号进行发帖、回帖。
        <h4>第二条各方权利和义务</h4>
        2.1一尘盯盘助手提供的是发帖、回帖服务，您接受本协议，意味着您同意我们使用您填写的一尘账号信息进行发帖、回帖，同时您必须遵守一尘的发帖、回帖等规定的服务条款<br />
        2.2用户了解并同意，一尘盯盘助手会根据您的授权使用您的一尘账户及密码操作发帖、回帖事宜，为了后续进一步向您提供服务，一尘盯盘助手只会在您的手机中记录您的前述相关信息。对于您的隐私信息一尘盯盘助手会严格保护。<br />
        2.3当您的在一尘发的帖子产生任何交易纠纷与一尘盯盘助手无任何关系，请自行承担。<br />
        2.4一尘盯盘助手可根据国家法律法规变化及维护交易秩序、保护
        消费者权益需要，不时修改本协议。<br />

        <van-button
          style="margin-top:10px"
          round
          block
          type="info"
          size="small"
          native-type="button"
          @click="(checked = true), (show = false)"
          >同意</van-button
        >
      </div>
    </van-popup>
  </van-form>
</template>
<script>
import { yichenLoginEx, yichenLogin } from '@/api/base';
import { getParamsLogin } from '@/utils/index';
export default {
  data() {
    return {
      username: '', //happyday008   筱星星
      password: '', //susu12345    focus822
      uuid: '',
      checked: false,
      show: false,
    };
  },
  methods: {
    handleLogin() {
      let that = this;
      this.$refs.loginForm
        .validate()
        .then(() => {
          that.onSubmit();
        })
        .catch(() => {});
    },
    onSubmit() {
      this.$toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true,
        message: '登录同步中~',
      });
      if (this.checked) {
        let obj = getParamsLogin(this.username, this.password);
        yichenLoginEx(obj).then(res => {
          this.$toast.clear();
          obj.grade = res.data.grade;
          window.localStorage.setItem('ycUserinfos', JSON.stringify(obj));
          if (this.$route.query.r) {
            window.location.href = decodeURIComponent(decodeURIComponent(this.$route.query.r));
            return;
          }
          this.$router.replace('/createPost/list');
        });
      } else {
        this.$toast('请阅读账号授权协议并勾选复选框');
      }
    },
  },
};
</script>
<style scoped>
.wra {
  font-size: 20px;
}
</style>
